import { SuggestionInput, SuggestionOutput } from '@allocab/allocab-commons-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { passengerApi } from '../services/network/Api';

const fetchSuggestions = (searchQuery: string | null) =>
  searchQuery
    ? passengerApi.get<SuggestionInput, SuggestionOutput, 'list'>('/suggestion/v1/address', {
        address: searchQuery,
      })
    : null;

export const useFetchSuggestions = (searchQueryParam: string | null) =>
  useQuery(queryKeys.user.fetchSuggestions(searchQueryParam), () => fetchSuggestions(searchQueryParam), {
    keepPreviousData: true,
  });
